export default "__VITE_ASSET__a59f9902__"